$(function () {
    $(".fancybox").fancybox({
        keys: {
            next: {
                34: 'up',   // page down
                39: 'left', // right arrow
                40: 'up'    // down arrow
            },
            prev: {
                33: 'down',   // page up
                37: 'right',  // left arrow
                38: 'down'    // up arrow
            },
            close: [27], // escape key
            play: [32], // space - start/stop slideshow
            toggle: [70]  // letter "f" - toggle fullscreen
        },
        tpl: {
            closeBtn: '<a title="' + window.closeBtn + '" class="fancybox-item fancybox-close" href="javascript:;"></a>',
            next: '<a title="' + window.nextBtn + '" class="fancybox-nav fancybox-next" href="javascript:;"><span></span></a>',
            prev: '<a title="' + window.prevBtn + '" class="fancybox-nav fancybox-prev" href="javascript:;"><span></span></a>',
        },
        afterLoad: function () {
            this.title = '<strong>' + this.title + '</strong>' + '<br ><a href="' + this.href + '" title="Download ' + this.title + '">Download</a>';
        },
        afterShow: function () {
            setTimeout(function () { $('.fancybox-prev').focus(); }, 1000);
        },
        helpers: {
            title: {
                type: 'inside'
            }
        }
    });
});